var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCartX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C1 2.44772 1.44772 2 2 2H5C5.46566 2 5.86968 2.32141 5.97439 2.77514L6.29255 4.15385H22C22.3087 4.15385 22.6002 4.29646 22.7896 4.54025C22.9791 4.78404 23.0453 5.10167 22.969 5.40085L20.969 13.247C20.8561 13.69 20.4571 14 20 14H8.56474L8.79551 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H8C7.53434 17 7.13032 16.6786 7.02561 16.2249L4.20449 4H2C1.44772 4 1 3.55228 1 3ZM8.1032 12H19.2229L20.7131 6.15385H6.75409L8.1032 12Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22C11.1046 22 12 21.1046 12 20C12 18.8954 11.1046 18 10 18C8.89543 18 8 18.8954 8 20C8 21.1046 8.89543 22 10 22Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 22C19.1046 22 20 21.1046 20 20C20 18.8954 19.1046 18 18 18C16.8954 18 16 18.8954 16 20C16 21.1046 16.8954 22 18 22Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartX2);
export default __webpack_public_path__ + "static/media/ShoppingCartX2.ce69311e59fff94bd0c12a5301bae666.svg";
export { ForwardRef as ReactComponent };